import { render } from "./ResultsPopup.vue?vue&type=template&id=c0079f66&scoped=true"
import script from "./ResultsPopup.vue?vue&type=script&lang=js"
export * from "./ResultsPopup.vue?vue&type=script&lang=js"

import "./ResultsPopup.vue?vue&type=style&index=0&id=c0079f66&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c0079f66"

export default script